<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="queryForm.majorCode" placeholder="专业名称" style="width:300px;">
                <el-option v-for="item in comboData.major" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.gradeCode" placeholder="年级名称" style="width:300px;">
                <el-option v-for="item in comboData.grade" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
        </div>

        <el-table v-if="showTableFlag" :data="tableData" @current-change="handleCurrentChange" v-loading="tableLoading"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" height="530" ref="mainTable">
            <el-table-column label="序号" width="50" align="center" fixed>
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="专业名称" prop="majorName" align="center" width="200px" fixed></el-table-column>
            <el-table-column label="年级名称" prop="gradeName" align="center" width="100px" fixed></el-table-column>
            <el-table-column label="班级名称" prop="className" align="center" width="200px" fixed></el-table-column>
            <el-table-column v-for="index in comboData.courseAttr.length" :key="index"
                :label="comboData.courseAttr[index-1].comboName+'学分'"
                :prop="'credit'+index"
                :formatter="creditFormatter"
                align="center"></el-table-column>
            <el-table-column label="总学分" prop="totalCredit" :formatter="creditFormatter" align="center" width="100px" fixed="right"></el-table-column>
            <el-table-column label="操作" align="center" width="100px" fixed="right">
                <template slot-scope="scope">
                    <el-button size="small" @click="setGraduateRequire(scope.row);" type="warning">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <!-- 表单区域 -->
        <el-dialog title="毕业要求设置" :visible.sync="settingDialogVisible" @closed="closeSettingDialog" width="900px" top="120px" append-to-body>
            <el-form ref="settingForm" :model="settingForm" label-width="200px" label-position="left" :rules="settingRules" :inline="true">
                <el-form-item label="专业名称" prop="majorName">
                    <div style="width:195px;">{{ settingForm.majorName }}</div>
                </el-form-item>
                <el-form-item label="年级名称" prop="gradeName">
                    <div style="width:195px;">{{ settingForm.gradeName }}</div>
                </el-form-item>
                <el-form-item v-for="index in comboData.courseAttr.length" :key="index" :label="comboData.courseAttr[index-1].comboName + '学分'" :prop="'credit'+index">
                    <el-input-number v-model="settingForm['credit'+index]" style="width:195px;" :min="0" :precision="3" :step="0.5"
                        :label="'请输入' + comboData.courseAttr[index-1].comboName + '学分'"></el-input-number>
                </el-form-item>
                <el-form-item label="总学分" prop="totalCredit">
                    <el-input-number v-model="settingForm.totalCredit" style="width:195px;" :min="0" :precision="3" :step="0.5" label="请输入总学分"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" @click="save">保存</el-button>
                <el-button @click="settingDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        props: ['graduateParam'],
        data() {
            return {
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    majorCode: null,
                    gradeCode: null,
                    year: null,
                },
                comboData: {
                    major: null,
                    grade: null,
                    courseAttr: [],
                },
                settingForm: {
                    id: null,
                    majorCode: null,
                    majorName: null,
                    gradeCode: null,
                    gradeName: null,
                    credit1: null,
                    credit2: null,
                    credit3: null,
                    credit4: null,
                    credit5: null,
                    credit6: null,
                    credit7: null,
                    credit8: null,
                    credit9: null,
                    credit10: null,
                    credit11: null,
                    credit12: null,
                    credit13: null,
                    credit14: null,
                    credit15: null,
                    totalCredit: null,
                },
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: {},
                settingDialogVisible: false,
                settingRules: {
                    totalCredit: [{
                        required: true,
                        trigger: ['blur'],
                        message: "请填写总学分",
                    }],
                },
                showTableFlag: false,
            };
        },
        mounted() {
            this.initData();
        },
        methods: {
            initData(){
                this.queryForm.year = this.graduateParam.year;
                this.initCombo();
                this.queryList();
            },
            initCombo() {
                this.$api.student.graduate.initGraduateRequireCombo({}).then((res) => {
                    this.comboData.major = res.data.data.major;
                    this.comboData.grade = res.data.data.grade;
                    this.comboData.courseAttr = res.data.data.courseAttr;
                }).catch((err) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.student.graduate.graduateRequireList({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.showTableFlag = true;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            creditFormatter(row, column, cellValue, index){
                return parseFloat(cellValue);
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.stuCode = null;
                this.queryForm.stuName = null;
                this.queryForm.className = null;
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            setGraduateRequire(rowData){
                this.settingForm.id = rowData.id;
                this.settingForm.majorName = rowData.majorName;
                this.settingForm.gradeName = rowData.gradeName;
                this.settingForm.credit1 = rowData.credit1;
                this.settingForm.credit2 = rowData.credit2;
                this.settingForm.credit3 = rowData.credit3;
                this.settingForm.credit4 = rowData.credit4;
                this.settingForm.credit5 = rowData.credit5;
                this.settingForm.credit6 = rowData.credit6;
                this.settingForm.credit7 = rowData.credit7;
                this.settingForm.credit8 = rowData.credit8;
                this.settingForm.credit9 = rowData.credit9;
                this.settingForm.credit10 = rowData.credit10;
                this.settingForm.credit11 = rowData.credit11;
                this.settingForm.credit12 = rowData.credit12;
                this.settingForm.credit13 = rowData.credit13;
                this.settingForm.credit14 = rowData.credit14;
                this.settingForm.credit15 = rowData.credit15;
                this.settingForm.totalCredit = rowData.totalCredit;

                this.settingDialogVisible = true;
            },
            save(){
                this.$refs['settingForm'].validate((valid) => {
                    if (valid) {
                        this.$api.student.graduate.saveGraduateRequire({
                            data: this.settingForm,
                        }).then((res) => {
                            if(res.data.data.state == 'Success') {
                                this.settingDialogVisible = false;
                                showNotify('成功', '保存成功', 'success', 1500);
                                this.queryList();
                            }else{
                                showNotify('错误', '保存失败', 'error', 3000);
                            }
                        }).catch((err) => {
                            showNotify('错误', error, 'error', 3000);
                        });
                    } else {
                        return false;
                    }
                });
            },
            closeSettingDialog(){
                this.settingDialogVisible = false;

                if(this.$refs['settingForm'] !== undefined){
                    this.$refs['settingForm'].clearValidate();
                    this.$refs['settingForm'].resetFields();
                }
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// graduateRequire.vue?cebde088